import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_STEP {
  email = 'email',
  payment = 'payment',
}

export enum MODULE_ROUTE {
  payment = 'PricingPaymentSubscriptionTest',
}

const isMobile = window.innerWidth < 768;

export const routes: RouteRecordRaw[] = isMobile
  ? [
      {
        path: '/:lang?/pricing/subscription-mobile/payment/',
        component: () =>
          import('@/modules/subscription-test/mobile/layout/LayoutPage.vue'),
        children: [
          {
            path: '',
            name: MODULE_ROUTE.payment,
            component: () =>
              import('@/modules/subscription-test/mobile/pages/DynamicPage.vue'),
            meta: {
              i18nAlias: 'pricing',
            },
          },
        ],
      },
    ]
  : [
      {
        path: '/:lang?/pricing/subscription-mobile/payment/',
        component: () =>
          import('@/modules/subscription-test/layout/LayoutPage.vue'),
        children: [
          {
            path: '',
            name: MODULE_ROUTE.payment,
            component: () =>
              import('@/modules/subscription-test/pages/payment/PagePayment.vue'),
            meta: {
              i18nAlias: 'pricing',
            },
          },
        ],
      },
    ];
